var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"16px","height":"16px","xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":"#checked-icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }